var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_vm._v("socket is hidden run")])}
var staticRenderFns = []

export { render, staticRenderFns }